import { CATYC4 } from "./CGUTranslation";
import { CATYC3 } from "./PPDTranslation";
import { CA1 } from "./translations1";
import { CA2 } from "./translations2";
import { CATYC1 } from "./TycsTranslation1";
import { CATYC2 } from "./TycsTranslation2";

const CA = { ...CA1, ...CA2, ...CATYC1, ...CATYC2, ...CATYC3, ...CATYC4 };
export { CA };